import { callApi } from './api';
import Course33VideoShare from '@/models/course-33-share';
import { useQuery } from '@tanstack/react-query';

// Admin-only Course-33 video review endpoint (admin-role gated, api PR #468).
const course33AdminApiUrl = import.meta.env.VITE_API_URL_V1 + '/admin/course-33';

export interface Course33SharesResult {
    shares: Course33VideoShare[];
    page: number;
    limit: number;
    /** True when another page exists after this one (no total is returned). */
    hasMore: boolean;
}

export interface Course33SharesQuery {
    userId?: string;
    /** Program day filter (1–21). Omit for all days. */
    day?: number;
    page: number;
    limit: number;
}

export const getCourse33Shares = async (params: Course33SharesQuery) => {
    const q = new URLSearchParams();
    q.set('page', String(params.page));
    q.set('limit', String(params.limit));
    if (params.userId) q.set('userId', params.userId);
    if (params.day !== undefined) q.set('day', String(params.day));
    return callApi<Course33SharesResult>({ url: `${course33AdminApiUrl}/shares?${q.toString()}`, method: 'GET' });
};

export const useCourse33Shares = (params: Course33SharesQuery) => {
    return useQuery({
        queryKey: ['course-33-shares', params],
        queryFn: () => getCourse33Shares(params),
    });
};
